// import { ChartData } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

declare global {
	interface Window { chart_config: any; }
}
document.addEventListener('DOMContentLoaded', () => {
	const chartColors = {
		blue: '#0066C0',
		blue_dk: '#085A70',
		blue_lt: '#4CABFF',
		cyan: '#00B0E3',
		cyan_lt: '#85E3FF',
		flower: '#9AC1F0',
		flower_lt: '#D3E4F8',
		grey: '#CCCCCC',
		mint_dk: '#E6F0EB',
		yellow: '#FEE000',
	};
	var colors = [
		'rgb(255, 99, 132)',   // red
		'rgb(54, 162, 235)',   // blue
		'rgb(255, 206, 86)',   // yellow
		'rgb(75, 192, 192)',   // green
		'rgb(153, 102, 255)',  // purple
		'rgb(255, 159, 64)'    // orange
	];
	function getChartColors(type: string) {
		// TODO: this is a little silly, let's rethink it
		let array: string[] = [];
		switch (type) {
			case 'line':
				array = [
					chartColors.grey
				];
				break;
			case 'pie':
				array = [
					chartColors.cyan,
					chartColors.yellow,
					chartColors.blue,
					chartColors.flower,
					chartColors.cyan_lt,
					chartColors.blue_lt,
					chartColors.flower_lt,
					chartColors.mint_dk,
					chartColors.blue_dk,
				];
				break;
			default:
				array = [
					chartColors.flower
				];
				break;
		}
		return array;
	}
	function getColIndex(table: HTMLTableElement, string: string) {
		return Array.from(table.tHead.rows[0].cells).map(cell => cell.textContent.trim()).indexOf(string);
	}
	function getValuesByCol(table: HTMLTableElement, string: string) {
		var index = getColIndex(table, string);
		var rows = table.tBodies[0].rows;
		var array = [];
		for (var i = 0; i < rows.length; i++) {
			array.push(rows[i].cells[index].textContent.trim());
		}
		return array;
	}
	function getDatasetsByRow(table: HTMLTableElement, string: string, stringRow: string) {
		var index = getColIndex(table, string);
		let rows = table.tBodies[0].rows;
		let array = [];

		interface Dataset {
			backgroundColor?: string,
			borderColor?: string;
			label: string;
			data: number[];
			hidden: boolean;
			tension: number;
			pointStyle: string;
			pointRadius: number;
			pointHoverRadius: number;
		};
		let template: Dataset = {
			backgroundColor: chartColors.grey,
			borderColor: chartColors.grey,
			label: '',
			data: [] as any[],
			hidden: false,
			tension: 0,
			pointStyle: 'circle',
			pointRadius: 4,
			pointHoverRadius: 8
		};

		while (colors.length < rows.length) {
			colors = colors.concat(colors);
		}
		for (let i = 0; i < rows.length; i++) {
			let dataset = { ...template };
			dataset.label = rows[i].cells[index].textContent;
			dataset.data = [];
			dataset.hidden = dataset.label != stringRow;

			let color = (dataset.label == stringRow) ? chartColors.grey : colors[i];
			dataset.borderColor = color;
			dataset.backgroundColor = color;

			for (let j = 0; j < rows[i].cells.length; j++) {
				if (j == index) continue;
				dataset.data.push(parseFloat(rows[i].cells[j].innerText));
			}
			array.push(dataset);
		}
		return array;
	}
	function getChartData(table: HTMLTableElement, chartConfig: any) {
		let labels = [];
		let datasets = [];

		if (chartConfig.x_axis.length == 1) {
			// let data = getValuesByCol(table, chartConfig.y_axis);
			let data = getValuesByCol(table, chartConfig.y_axis).map(value => parseFloat(value.replace(/,/g, '')));
			// console.log(data);
			datasets = [
				{
					label: chartConfig.y_axis,
					data: data,
					backgroundColor: getChartColors(chartConfig.type)
				}
			];
			labels = getValuesByCol(table, chartConfig.x_axis[0]);
		} else {
			datasets = getDatasetsByRow(table, chartConfig.y_axis, chartConfig.dataset);
			labels = chartConfig.x_axis;
		}
		return {
			labels: labels,
			datasets: datasets
		}
	}

	function setupFilter(chart: any, chartConfig: string){
		if (chartConfig != 'line') return;
		let targetElement = chart.canvas.closest('.wp-block-statistics').querySelector('.wp-block-statistics-filter');
		if (!targetElement) return;

		// Get the labels from the datasets
		let labels = chart.data.datasets.map((dataset: any) => dataset.label);

		/* ----- Select Menu ----- */
		let select = document.createElement('select');
		let blank = document.createElement('option');
		blank.value = '';
		blank.text = 'Select';
		select.appendChild(blank);
		labels.forEach((label: any) => {
			let option = document.createElement('option');
			option.value = label;
			option.text = label;
			select.appendChild(option);
		});
		select.addEventListener('change', () => {
			let checkbox = document.getElementById(chart.id + '-' + select.value) as HTMLInputElement;
			if (checkbox) {
				checkbox.checked = !checkbox.checked;
				let event = new Event('change');
				checkbox.dispatchEvent(event);
			}
		});
		let selectLabel = document.createElement('label');
		selectLabel.appendChild(document.createTextNode(targetElement.getAttribute("data-select-label")));
		targetElement.appendChild(selectLabel);
		targetElement.appendChild(select);

		/* ----- Checkboxes ----- */
		let checkboxes = document.createElement('ul');
		labels.forEach((label:any, index:any) => {
			let liElement = document.createElement('li');
			let labelElement = document.createElement('label');
			labelElement.appendChild(document.createTextNode(label));

			let checkbox = document.createElement('input');
			checkbox.type = 'checkbox';
			checkbox.id = chart.id + "-" + label;
			checkbox.name = label;
			checkbox.value = label;

			checkbox.addEventListener('change', () => {
				chart.data.datasets[index].hidden = !checkbox.checked;
				chart.update(); // Update the chart to reflect the changes
			});

			labelElement.insertBefore(checkbox, labelElement.firstChild);
			liElement.appendChild(labelElement);
			checkboxes.appendChild(liElement);
		});
		let checkboxesLabel = document.createElement('label');
		checkboxesLabel.appendChild(document.createTextNode(targetElement.getAttribute("data-checkboxes-label")));
		targetElement.appendChild(checkboxesLabel);
		targetElement.appendChild(checkboxes);
	}

	document.querySelectorAll('.statistics-chart[data-chart-config]').forEach(async block => {
		const chartConfig = window.chart_config[block.getAttribute("data-chart-config")];
		block.removeAttribute("data-chart-config");

		const table = block.getElementsByTagName('table')[0];
		const figure = table.closest('figure');
		const chartData = getChartData(table, chartConfig);

		const canvas = document.createElement('canvas');
		(figure.parentElement).insertBefore(canvas, figure);

		const chart = new (await import('chart.js/auto')).Chart(canvas, {
			plugins: [ChartDataLabels],
			type: chartConfig.type,
			data: chartData,
			options: {
				datasets: {
					pie: {
						borderWidth: 0,
						radius: ( 360 / 460 * 100 ) + '%',
						aspectRatio: (680 / 460)
					},
					bar: {
					}
				},
				indexAxis: chartConfig.orientation == 'vertical' ? 'y' : 'x',
				layout: {
				},
				plugins: {
					datalabels: {
						anchor: 'end',
						align: 'end',
						offset: 6,
						color: '#0066C0',
						display: chartConfig.type == 'bar',
						font: {
							weight: 'bold'
						},
						formatter: function (value: any, context: any) {
							// TODO: add configuration for decimal places
							if (chartConfig.type == 'bar' && chartConfig.orientation == 'horizontal') {
								let factor = Math.pow(10, 1); // 1 is the number of decimal places
								return Math.round(value * factor) / factor;
							} else {
								return value;
							}
						}
					},
					legend: {
						display: chartConfig.type == 'pie'
					}
				},
				responsive: true,
				scales: chartConfig.type === 'line' ? {
					y: {
						afterDataLimits: (axis: any) => {
							// Extend the range by 2 points
							axis.max += 1;
							axis.min -= 1;
						}
					}
				} : (chartConfig.options?.scales || {}) // Use the scales from the original options if defined, otherwise use an empty object
			}
		});

		setupFilter(chart, chartConfig.type);
	});
});